import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface PersonalRecord {
    individual_uuid: string;
    individual_name: string;
    event_type: string;
    best_result: number;
    result_unit: string;
    meet_name?: string;
    meet_date?: string;
}

interface GetPRsFilters {
    'filter.individual'?: string[];
    'filter.group'?: string;
}

interface PRsResponse {
    personal_records: PersonalRecord[];
}

type ReturnType = Promise<AxiosResponse<PRsResponse>>;

const getPersonalRecords = (filters: GetPRsFilters = {}): ReturnType => {
    return Request.get('/workouts/track-events/personal-records', {
        params: filters,
    });
};

export default getPersonalRecords;
